import { authStateReady } from "../utils/authState";
import axios from 'axios';
import { getAuth } from "firebase/auth";

const BASE_URL = 'https://europe-west3-hyper-e122e.cloudfunctions.net';

export default {

async addCareer(career) {
  try {
    const currentUser = getAuth().currentUser;
    if (!currentUser) throw new Error("❌ Пользователь не авторизован");

    const token = await currentUser.getIdToken();

    const response = await axios.post(
      `${BASE_URL}/add_career`,
      {
        career
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      }
    );

    console.log("✅ Карьера успешно добавлена:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Ошибка при добавлении карьеры:", error);
    throw error;
  }
},

async deleteCareer(careerId) {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error("❌ Пользователь не авторизован");

    const token = await currentUser.getIdToken(true);
    if (!token) throw new Error("❌ Не удалось получить токен");

    const response = await axios.post(
      `${BASE_URL}/delete_career`,
      { career_id: careerId },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );

    console.log("🗑 Карьера удалена:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Ошибка при удалении карьеры:", error);
    throw error;
  }
},

  async searchUniversities(query) {
  try {
    const response = await axios.get(`${BASE_URL}/search_universities`, {
      params: { query }
    });
    return response.data;
  } catch (error) {
    console.error("❌ Ошибка поиска университетов:", error);
    return [];
  }
},

async addEducation(education) {
  try {
    const currentUser = await authStateReady();

    if (!currentUser) {
      throw new Error("❌ Пользователь не авторизован");
    }

    const token = await currentUser.getIdToken();

    const response = await axios.post(
      `${BASE_URL}/add_education`,
      { education },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("✅ Образование успешно добавлено:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Ошибка при добавлении образования:", error);
    throw error;
  }
},

  async deleteEducation(educationId) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken();
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(
        `${BASE_URL}/delete_education`,
        {
          education_id: educationId
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      console.log("🗑 Образование удалено:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при удалении образования:", error);
      throw error;
    }
  },

  async addLanguage(payload) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");
      const token = await currentUser.getIdToken(true);
      const body = payload.language
        ? payload
        : { language: payload }; 

      const res = await axios.post(
        `${BASE_URL}/add_language`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (err) {
      console.error("❌ Ошибка при добавлении языка:", err.response?.data || err.message);
      throw err;
    }
  },

  async deleteLanguage(languageId) {
    try {
      if (!languageId) {
        throw new Error("languageId не передан");
      }
  
      const currentUser = await authStateReady();
  
      if (!currentUser) {
        throw new Error("❌ Пользователь не авторизован");
      }
  
      const token = await currentUser.getIdToken(true);
  
      const response = await axios.post(
        `${BASE_URL}/delete_language`,
        {
          language_id: languageId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log("🗑️ Язык успешно удалён:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при удалении языка:", error);
      throw error;
    }
  },

  async getMySummary(userId) {
    try {
      const response = await axios.post(
        `${BASE_URL}/get_my_summary`,
        JSON.stringify({ user_id: userId }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log("✅ Резюме успешно получено:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при получении резюме:", error);
      throw error;
    }
  },

  async updateProfileSocial(userId, social) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      // Получаем актуальный токен (с продлением)
      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      console.log("📤 Отправляем запрос на update_profile_social для:", userId, social);

      const response = await axios.post(`${BASE_URL}/update_profile_social`, {
        user_id: userId,
        social: social
      }, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      console.log("✅ Соцсети успешно обновлены:", response.data);
      return response.data;

    } catch (error) {
      console.error("❌ Ошибка при обновлении соцсетей:", error.response?.data || error.message);
      throw error;
    }
  },

  async updateWorkingProfiles(userId, workingProfiles) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Токен авторизации не найден");

      const response = await axios.post(`${BASE_URL}/update_working_profiles`, {
        user_id: userId,
        working_profiles: workingProfiles
      }, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (response.data?.success) {
        console.log("✅ Рабочие профили успешно обновлены");
        return true;
      } else {
        console.warn("⚠️ Сервер не вернул успех:", response.data);
        return false;
      }
    } catch (error) {
      console.error("❌ Ошибка при обновлении рабочих профилей:", error);
      throw error;
    }
  }

};